import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { graphPaletteKey } from '../../atoms/graphPaletteAtom';
import {
  GRAPH_PALETTE_KEYS,
  GRAPH_PALETTES,
  GraphPaletteKey,
} from '../../constants/ColorsForGraph';

// Number of swatches previewed for each palette.
const PREVIEW_LENGTH = 5;

const PalettePreview = ({ paletteKey }: { paletteKey: GraphPaletteKey }) => (
  <Box sx={{ display: 'flex', gap: '2px' }}>
    {GRAPH_PALETTES[paletteKey].slice(0, PREVIEW_LENGTH).map((color) => (
      <Box
        key={color}
        sx={{
          width: 12,
          height: 12,
          borderRadius: '2px',
          backgroundColor: color,
        }}
      />
    ))}
  </Box>
);

export const GraphPaletteSelector = (): JSX.Element => {
  const { t } = useTranslation();
  const [selectedPalette, setSelectedPalette] =
    useRecoilState<GraphPaletteKey>(graphPaletteKey);

  const handleChange = (event: SelectChangeEvent) => {
    setSelectedPalette(event.target.value as GraphPaletteKey);
  };

  return (
    <FormControl sx={{ width: '100%' }} size="small">
      <InputLabel id="graph-palette-label">
        {t('measurement.colorPalette')}
      </InputLabel>
      <Select
        labelId="graph-palette-label"
        id="graph-palette"
        value={selectedPalette}
        label={t('measurement.colorPalette')}
        onChange={handleChange}
        sx={{ backgroundColor: '#fff' }}
      >
        {GRAPH_PALETTE_KEYS.map((paletteKeyOption) => (
          <MenuItem key={paletteKeyOption} value={paletteKeyOption}>
            <Box
              sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}
            >
              <PalettePreview paletteKey={paletteKeyOption} />
              {t(`graphPalette.${paletteKeyOption}`)}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default GraphPaletteSelector;
